// Logout modal: scope choice (this device / all devices). Confirming calls
// the API's /frm/auth/logout (idempotent; 'all' kills every session of the
// user) and goes STRAIGHT to the login page — an explicit logout is a
// deliberate exit, so no return target and nothing in the URL survives it
// (upper request #26); the confirmation toast crosses via sessionStorage.
export function initLogout() {
	const modalEl = document.getElementById('logoutModal');

	// The user dropdown uses auto-close="outside", so close it manually when the
	// logout modal opens (otherwise it stays open behind the backdrop).
	if (modalEl && window.bootstrap) {
		modalEl.addEventListener('show.bs.modal', () => {
			const toggle = document.querySelector('.topbar-user[data-bs-toggle="dropdown"]');
			if (toggle) {
				const dd = window.bootstrap.Dropdown.getInstance(toggle);
				if (dd) dd.hide();
			}
		});
	}

	document.querySelectorAll('[data-logout-confirm]').forEach((btn) => {
		btn.addEventListener('click', async () => {
			const scope = (document.querySelector('input[name="logoutScope"]:checked') || {}).value || 'this';
			btn.disabled = true;
			if (window.g && window.g.fetch) {
				await window.g.fetch('/frm/auth/logout', { everywhere: scope === 'all' });
			}
			const login = btn.dataset.loginUrl;
			if (login) {
				try { sessionStorage.setItem('genus-logged-out', '1'); } catch { /* storage may be blocked */ }
				window.location.href = login;
			} else {
				window.location.reload(); // no login page declared — anonymous reload
			}
		});
	});
}
